// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__EzcYb","active":"MenuItem_active__VFobU","icon":"MenuItem_icon__aJVya","title":"MenuItem_title__o-jjo"};